module.exports = __webpack_public_path__ + "static/c4dd0b937b45661da5f39879f35addbd8eb04335f953b7aa612e6a6a654081f2-8b972d52aee2dbe8305812f319cce806.png";